import { RemotePackage } from "../../../../data/usecases/package/remote-package-controller";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemotePackage = (): RemotePackage =>
  new RemotePackage("/packages", makeAxiosHttpClient());
